import { slk } from "survey-core";

export default function SetLicenseKey() {
  slk(
    "YTdiNWFmNzItYjY3Ny00MmYzLTlmNDUtOGI3MTgwNWQwZTE3OzE9MjAyNy0wNi0zMCwyPTIwMjctMDYtMzAsND0yMDI3LTA2LTMwLDg9MjAyNy0wNi0zMA==",
  );
}
